var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 39.876,
  height: 30.631,
  viewBox: "0 0 39.876 30.631"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-583.916 -296)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.794,46.325h32.12a1.276,1.276,0,0,0,1.2-1.334V22.114a1.276,1.276,0,0,0-1.2-1.334H3.794a1.276,1.276,0,0,0-1.2,1.334V44.991a1.276,1.276,0,0,0,1.2,1.334ZM3.622,22.114a.182.182,0,0,1,.172-.191h32.12a.182.182,0,0,1,.172.191V44.991a.182.182,0,0,1-.172.191H3.794a.182.182,0,0,1-.172-.191V22.114ZM39.708,47.346v1.068a.49.49,0,0,1-.463.512H.463A.49.49,0,0,1,0,48.414V47.346H16.308a.663.663,0,0,0,.622.516h5.849a.663.663,0,0,0,.622-.516Z",
  transform: "translate(584 275.22)"
}), /*#__PURE__*/React.createElement("rect", {
  width: 38.876,
  height: 2.802,
  rx: 1.401,
  transform: "translate(584.416 323.33)",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1
}))));
export default __webpack_public_path__ + "static/media/electronics.abbe5d79.svg";
export { SvgComponent as ReactComponent };